(() => {
  const init = (section) => {
    let sectionPricingTable;

    if (document.currentScript) {
      sectionPricingTable = document.currentScript.parentElement;
    } else {
      sectionPricingTable = section;
    }

    if (
      !sectionPricingTable ||
      !sectionPricingTable.classList.contains("pricing-table-section")
    )
      return;

    const rate =
      (window.Shopify &&
        window.Shopify.currency &&
        Number(window.Shopify.currency.rate)) ||
      1;

    sectionPricingTable
      .querySelectorAll("[data-price]")
      .forEach((priceEl) => {
        const basePrice = Number(priceEl.dataset.price);
        if (Number.isNaN(basePrice)) return;

        const convertedPrice = Math.round(basePrice * rate);
        const format =
          priceEl.dataset.currencyCodeEnabled === "true"
            ? window.theme.moneyWithCurrencyFormat
            : window.theme.moneyFormat;
        const prefix = priceEl.dataset.pricePrefix || "";
        const suffix = priceEl.dataset.priceSuffix || "";

        priceEl.textContent = prefix + formatMoney(convertedPrice, format) + suffix;
      });
  };

  init();

  document.addEventListener("shopify:section:load", function (section) {
    init(section.target);
  });
})();
